/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { useEffect } from '@wordpress/element';
import memoize from 'memize';
import times from 'lodash/times';
import { withDispatch, select } from '@wordpress/data';
import { compose } from '@wordpress/compose';

import {
	InnerBlocks,
} from '@wordpress/block-editor';

/**
 * Inner dependencies.
 */
import Inspector from './inspector';
import BaseWrapper from '../../components/base-wrapper';
// import { default as styling } from './inline-styles';
import { updateBlockStyle } from './inline-styles';

/**
 * Constants
 */
const ALLOWED_BLOCKS = [ 'gutenify/testimonial' ];

/**
 * Returns the layouts configuration for a given number of feature items.
 *
 * @param {number} count Number of feature items.
 *
 * @return {Object[]} Columns layout configuration.
 */
const getCount = memoize( ( count ) => {
	return times( count, () => [ 'gutenify/testimonial', {
		className: 'has-shadow-dark',
	} ] );
} );

const Edit = ( props ) => {
	useEffect( () => {
		updateBlockStyle( {}, props );
	}, [] );
	const { attributes, isSelected, className, clientId } = props;
	const { layout, columnSize, hideRating } = attributes;
	const wrapperClasses = classnames(
		className,
		`gutenify-testimonials-block-wrapper gutenify-testimonials-${ layout }`,
		`gutenify-testimonials-col-${ columnSize }`,
		hideRating && 'gutenify-testimonials-hide-rating',
	);

	return (
		<div className={ wrapperClasses }>

			{ isSelected && <Inspector { ...props } /> }
			<BaseWrapper { ...props } sectionID={ clientId }>
				<div className="gutenify-testimonials-block">
					<InnerBlocks
						allowedBlocks={ ALLOWED_BLOCKS }
						template={ getCount( 2 ) }
						templateInsertUpdatesSelection={ false }
						orientation={ 'horizontal' }
						__experimentalCaptureToolbars={ true }
						renderAppender={ () => (
							<InnerBlocks.ButtonBlockAppender />
						) }
					/>
				</div>
			</BaseWrapper>

		</div>
	);
};

export default compose( [
	withDispatch( ( dispatch, props ) => {
		const { clientId } = props;

		return {
			updateInnerBlocks( template ) {
				const children = select( 'core/block-editor' ).getBlocksByClientId( clientId )[ 0 ].innerBlocks;
				children.forEach( function( child ) {
					if ( 'gutenify/testimonial' === child.name ) {
						dispatch( 'core/block-editor' ).updateBlockAttributes( child.clientId, {
							layout: template.name,
							titleAlign: template.titleAlign,
							imageAlign: template.imageAlign,
							ratingAlign: template.ratingAlign,
						} );
						const grandChildren = select( 'core/block-editor' ).getBlocksByClientId( child.clientId )[ 0 ].innerBlocks;
						grandChildren.forEach( function( grandChild ) {
							if ( 'core/image' === grandChild.name ) {
								dispatch( 'core/block-editor' ).updateBlockAttributes( grandChild.clientId, { align: template.imageAlign } );
							}
							if ( 'core/heading' === grandChild.name ) {
								dispatch( 'core/block-editor' ).updateBlockAttributes( grandChild.clientId, { textAlign: template.titleAlign } );
							}
							if ( 'core/paragraph' === grandChild.name ) {
								dispatch( 'core/block-editor' ).updateBlockAttributes( grandChild.clientId, { align: template.titleAlign } );
							}
							if ( 'gutenify/star-rating' === grandChild.name ) {
								dispatch( 'core/block-editor' ).updateBlockAttributes( grandChild.clientId, { textAlignment: template.ratingAlign } );
							}
						} );
					}
				} );
			},
		};
	} ),
] )( Edit );
